"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
var React = require("react");
var adfox_api_1 = require("./adfox_api");
__export(require("./middlewares"));
var adfox_api_2 = require("./adfox_api");
exports.getAdFoxBannerContext = adfox_api_2.getAdFoxBannerContext;
var api_1 = require("./api");
exports.fetchTargets = api_1.fetchTargets;
var AdFoxBanner = /** @class */ (function (_super) {
    __extends(AdFoxBanner, _super);
    function AdFoxBanner(props) {
        var _this = _super.call(this, props) || this;
        var context = props.context, middleware = props.middleware;
        if (!context && !middleware) {
            throw new Error('AdFox component expects context or context fetching middleware');
        }
        _this.state = {
            context: context,
            isLoading: true
        };
        return _this;
    }
    AdFoxBanner.prototype.componentDidMount = function () {
        var _this = this;
        if (this.state.context || !this.props.middleware) {
            return;
        }
        this.props.middleware()
            .then(adfox_api_1.getAdFoxBannerContext)
            .then(function (context) {
            _this.setState({ context: context, error: undefined, isLoading: false });
        })["catch"](function (error) {
            _this.setState({ context: undefined, error: error, isLoading: false });
        });
    };
    AdFoxBanner.prototype.render = function () {
        var _a = this.props, renderFailure = _a.renderFailure, renderFetched = _a.renderFetched, renderLoading = _a.renderLoading;
        var _b = this.state, context = _b.context, isLoading = _b.isLoading, error = _b.error;
        if (error && renderFailure) {
            return renderFailure(error);
        }
        if (isLoading && renderLoading) {
            return renderLoading();
        }
        if (context) {
            return renderFetched(context);
        }
        return null;
    };
    return AdFoxBanner;
}(React.Component));
exports.AdFoxBanner = AdFoxBanner;
//# sourceMappingURL=react.js.map